import { IntlTelInputComponent } from './../intl-tel-input/intl-tel-input.component';
import { InputComponent } from './input.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgxMaskModule } from 'ngx-mask'
import { FormsModule } from '@angular/forms'
import { CurrencyMaskModule } from 'ng2-currency-mask'
import { AutofocusDirective } from '../directives/autofocus.directive'

@NgModule({
	declarations: [InputComponent, AutofocusDirective, IntlTelInputComponent],
	imports: [CommonModule, FormsModule, NgxMaskModule.forChild(), CurrencyMaskModule],
	exports: [InputComponent, AutofocusDirective],
})
export class InputModule {}
